import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import type { GuideFaq } from "./guidesContent";

export function FaqItem({ faq }: { faq: GuideFaq }) {
  return (
    <Disclosure
      as="div"
      className="border-b border-gray-200 dark:border-gray-800 last:border-b-0"
    >
      {({ open }) => (
        <>
          <Disclosure.Button className="flex w-full items-center justify-between gap-4 bg-transparent border-none py-3 px-1 text-left cursor-pointer group">
            <span className="text-sm font-medium text-gray-900 dark:text-gray-100 group-hover:text-squawk-blue transition-colors">
              {faq.q}
            </span>
            <ChevronDownIcon
              className={`h-4 w-4 shrink-0 text-gray-400 transition-transform ${
                open ? "rotate-180" : ""
              }`}
              aria-hidden="true"
            />
          </Disclosure.Button>
          <Disclosure.Panel className="pb-4 px-1 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
            {faq.a}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
